<template>
    <div class="cz2__steps-options__actions--share">
        <btn
            @click="sharePop"
            onDark
            class="cz2__btn--outline"
        >
            <div class="cz2__btn-content-wrapper">
                <img
                    :src="shareIcon"
                    alt=""
                    width="13"
                    height="14"
                >
                <span>
                    {{$t('ACTION_SHARE')}}
                </span>
            </div>
        </btn>

        <btn
            @click="downloadPopImage"
            onDark
            class="cz2__btn--outline"
        >
            <div class="cz2__btn-content-wrapper">
                <img
                    :src="downloadIcon"
                    alt=""
                    width="11"
                    height="14"
                >
                <span>
                    {{$t('ACTION_DOWNLOAD')}}
                </span>
            </div>
        </btn>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__actions {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .cz2__steps-options__actions--share {
                margin-top: 16px;

                width: 100%;
                display: flex;
                gap: 8px;

                @include respond-above(sm) {
                    gap: 16px;
                }

                .download-link {
                    text-decoration: none;
                }

                .cz2__btn--outline {
                    background-color: black;
                    font-size: 15px;
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50%;
                    padding: 0;
                }

                .cz2__btn-content-wrapper {
                    display: flex;
                    align-items: baseline;
                    justify-content: center;
                    gap: 6px;
                }

                @include respond-above(lg) {
                    .cz2__btn--outline {
                        font-size: 22px;
                    }
                }
            }
        }
    }
</style>

<script>
    import axios from 'axios';
    import FileSaver from 'file-saver';

    import share from '../assets/icons/share-icons/share.svg';
    import download from '../assets/icons/share-icons/download.svg';

    import Btn from './ui/Btn.vue';

    export default {
        components: {
            Btn,
        },

        data() {
            return {
                shareIcon: share,
                downloadIcon: download,
                fbScriptSrc: 'https://connect.facebook.net/en_US/sdk.js',
            };
        },

        computed: {
            popControllers() {
                return this.$store.getters.popControllers;
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            boxNames() {
                return Object.values(this.$store.state.customizer.boxNamesByController).join('_');
            },

            fileName() {
                const boxName = this.isTwoPack ? this.boxNames : this.boxName;

                return boxName && boxName.length > 0 ? boxName : this.$t('NO_NAME');
            },
        },

        mounted() {
            this.checkForFbScript();
        },

        methods: {
            sharePop() {
                let popImageUrl = null;

                this.popControllers.forEach((controller) => {
                    const tags = controller.collectActiveTags();

                    controller.trackAction({
                        action: 'share',
                        tags,
                    });
                });

                this.$store.dispatch('customizerDone', { saveOnly: true })
                    .then((recipeData) => {
                        const preview = recipeData.recipe.views.find((view) => view.code === 'Preview');

                        if (window.navigator.share) {
                            fetch(preview.previewPng).then((response) => response.blob()).then((image) => {
                                const fileName = `${this.boxName}.png`;

                                const data = {
                                    files: [
                                        new File([image], fileName, {
                                            type: image.type,
                                        }),
                                    ],
                                    title: this.boxName,
                                };

                                window.navigator.share(data);
                            });
                        } else {
                            popImageUrl = `https:${preview.previewPng}`;

                            // eslint-disable-next-line no-undef
                            FB.ui({
                                method: 'share',
                                href: popImageUrl,
                            }, () => {});
                        }
                    });
            },

            downloadPopImage() {
                let popImageUrl = null;

                this.popControllers.forEach((controller) => {
                    const tags = controller.collectActiveTags();

                    controller.trackAction({
                        action: 'download',
                        tags,
                    });
                });

                this.$store.dispatch('customizerDone', { saveOnly: true })
                    .then((recipeData) => {
                        const preview = recipeData.recipe.views.find((view) => view.code === 'Preview');

                        popImageUrl = preview.previewPng;

                        axios.get(popImageUrl, { responseType: 'blob' }).then((response) => {
                            const fileName = `${this.fileName}.png`;

                            FileSaver.saveAs(response.data, fileName);
                        });
                    });
            },

            checkForFbScript() {
                if (window.FB == null) {
                    this.addFacebookScript();
                }
            },

            addFacebookScript() {
                const facebookScript = document.createElement('script');

                facebookScript.setAttribute('src', this.fbScriptSrc);

                // FB won't load with these from the "real" test page on CDN...
                // facebookScript.setAttribute('crossorigin', 'anonymous');
                // facebookScript.setAttribute('async', true);
                // facebookScript.setAttribute('defer', true);

                document.body.appendChild(facebookScript);

                window.fbAsyncInit = () => {
                    // eslint-disable-next-line no-undef
                    FB.init({
                        appId: '2802097273142792',
                        autoLogAppEvents: true,
                        xfbml: true,
                        version: 'v14.0',
                    });
                };
            },
        },
    };
</script>
